<section>
  <div class="container-fluid">
    <div class="row mt-2 border Page-Header">
      <h6 class="HeadContent">
        <span class="p-2"
          >Admin - Course Plan Management - {{ coursePlanMode }} Course Plan
        </span>
      </h6>
    </div>

    <form [formGroup]="addCoursePlanForm" (ngSubmit)="formSubmit()">
      <div class="card my-2" *ngIf="!examAgencyRequestParam.coursePlanId">
        <div class="card-header header-clone text-white text-uppercase fw-bold">
          Clone From Previous Course Plans
        </div>
        <div class="row my-2 ">
          <!-- Clone from Course -->
          <div class="col-md-5">
            <div class="row" *ngIf="!examAgencyRequestParam.coursePlanId">
              <div class="col-md-6 px-md-0 d-flex align-items-center justify-content-md-end">
                <label class="form-label mb-0">Clone from Course:</label>
              </div>
            <div class="col-md-6">
              <div class="d-flex align-items-center gap-2">
                <select
                  class="form-control form-control-sm inputfield-txt flex-grow-1"
                  formControlName="Course"
                  (change)="onCourseChange($event)"
                >
                  <option hidden></option>
                  <option *ngFor="let code of courseList" [value]="code.Course_Id">
                    {{ code.Exam_Year }}: {{ code.Course_Name }}
                  </option>
                </select>


              </div>
            </div>

            </div>
          </div>

          <!-- Clone from Course Plan -->
          <div class="col-md-5 d-flex gap-2">
            <div class="row w-83" *ngIf="!examAgencyRequestParam.coursePlanId">
              <div class="col-md-3 px-md-0 d-flex align-items-center ">
                <label class="form-label mb-0">Clone from Course Plan:</label>
              </div>
              <div class="col-md-6">
                <select
                  class="form-control form-control-sm inputfield-txt"
                  formControlName="Clone_Course_Plan"
                  (change)="OnCoursePlanChange($event)"
                >
                  <option hidden></option>
                  <option *ngFor="let code of coursePlans" [value]="code.Course_Plan_Id">
                    {{ code.Course_Plan_Name }}
                  </option>
                </select>
              </div>
            </div>
            <div>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  *ngIf="addCoursePlanForm?.get('Course')?.value"
                  (click)="clearCourseSelection()"
                >
                  Clear
                </button>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-4">

          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0">Course Name</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                formControlName="Course_Name"
                type="text"
                class="form-control form-control-sm input-txt"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0 label-red">*</div>
              <div class="p-0">Plan Type</div>
            </div>
            <div class="col-md-5 max-space-height">
              <select
                class="form-control form-control-sm inputfield-txt"
                formControlName="Course_Plan_Type_Code"
                (change)="onPlanTypeChange($event)"
                [ngClass]="
                  addCoursePlanForm.get('Course_Plan_Type_Code')?.touched &&
                  addCoursePlanForm.get('Course_Plan_Type_Code')?.invalid
                    ? 'red-border-required'
                    : ''
                "
              >
                <option hidden></option>
                <option
                  class="border-bottom"
                  *ngFor="let code of coursePlanType"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0 label-red">*</div>
              <div class="p-0">Course Plan Name</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                formControlName="Course_Plan_Name"
                type="text"
                class="form-control form-control-sm input-txt"
                [ngClass]="
                addCoursePlanForm.get('Course_Plan_Name')?.touched &&
                addCoursePlanForm.get('Course_Plan_Name')?.invalid
                  ? 'red-border-required'
                  : ''
              "
                [title]="addCoursePlanForm.get('Course_Plan_Name')?.value ?  addCoursePlanForm.get('Course_Plan_Name')?.value :''"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0 label-red">*</div>
              <div class="p-0">Available Date</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                formControlName="Course_Plan_Available_Date"
                type="date"
                [attr.min]="today"
                class="form-control form-control-sm input-txt w-50"
                [ngClass]="
                  addCoursePlanForm.get('Course_Plan_Available_Date')?.touched &&
                  addCoursePlanForm.get('Course_Plan_Available_Date')?.invalid
                    ? 'red-border-required'
                    : ''
                "
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0">Released?</div>
            </div>
            <div class="col-md-6  max-space-height">
              <input type="checkbox" formControlName="Released_Ind" />
              <span *ngIf="isSubs" class="mx-2 text-danger">{{
                messageRelease
              }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0">Number of Trial  Days</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                type="number"
                formControlName="Trial_Number_Of_Days"
                onKeyPress="if(this.value.length==10) return false;"
                (keypress)="preventEnteringString($event, 10)"
                class="form-control form-control-sm input-txt w-35"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0 label-red">*</div>
              <div class="p-0">Course Duration</div>
            </div>
            <div class="col-md-5 max-space-height">
              <select
                formControlName="Course_Duration_Type_Code"
                class="form-control form-control-sm inputfield-txt"
                [ngClass]="
                  addCoursePlanForm.get('Course_Duration_Type_Code')?.touched &&
                  addCoursePlanForm.get('Course_Duration_Type_Code')?.invalid
                    ? 'red-border-required'
                    : ''
                "
              >
                <option hidden></option>
                <option
                  class="border-bottom"
                  *ngFor="let code of courseDurationType"
                  [value]="code.Code"
                >
                  {{ code.Description }}
                </option>
              </select>
            </div>
          </div>

        </div>
        <div class="col-md-4">

          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0">Standard Price</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                formControlName="Course_Standard_Price"
                type="text"
                [appTwoDigitDecimaNumber]="2"
                onKeyPress="if(this.value.length==10) return false;"
                [max]="9999999999"
                class="form-control form-control-sm input-txt text-end w-50"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0">Current Offer Price</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                type="text"
                formControlName="Course_Current_Offer_Price"
                [appTwoDigitDecimaNumber]="2"
                onKeyPress="if(this.value.length==10) return false;"
                class="form-control form-control-sm input-txt text-end w-50"
              />
              <div *ngIf="addCoursePlanForm.hasError('greaterThanStandard')" class="text-danger">
                Offer price has to be less than the Standard price
              </div>

            </div>

          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0">Current Offer Price End Date</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                type="date"
                formControlName="CoursePlanCurrentOfferPriceEndDate"
                class="form-control form-control-sm input-txt w-50"
                [ngClass]="endCtrl?.touched && endCtrl?.errors?.['endBeforeStart'] ? 'red-border-required' : ''"
              />
              <small class="text-danger"
                    *ngIf="endCtrl?.touched && endCtrl?.errors?.['endBeforeStart']">
                End date can’t be earlier than Available Date.
              </small>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0">Upgradable?</div>
            </div>
            <div class="col-md-6 max-space-height">
              <input type="checkbox" formControlName="Upgradable_Ind" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height flex-row-reverse">
              <div class="p-0">Best Value?</div>
            </div>
            <div class="col-md-6 max-space-height">
              <input type="checkbox" (change)="onBestValueChange($event)" formControlName="Best_Value_Ind" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6  px-md-0 d-flex max-space-height justify-content-md-start text-md-end flex-row-reverse">
              <div class="p-0">Number of Hours of Material Included</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                formControlName="Number_Of_Hours_Of_Materials_Included"
                type="number"
                onKeyPress="if(this.value.length==10) return false;"
                (keypress)="preventEnteringString($event, 10)"
                class="form-control form-control-sm input-txt w-35"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height justify-content-md-start text-md-end flex-row-reverse">
              <div class="p-0">Number of Questions Included</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                type="number"

                formControlName="Number_Of_Questions_Incuded"
                onKeyPress="if(this.value.length==10) return false;"
                (keypress)="preventEnteringString($event, 10)"
                class="form-control form-control-sm input-txt w-35"
              />
            </div>
          </div>

        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height justify-content-md-start flex-row-reverse text-md-end">
              <div class="p-0">Number of Lesson Notes Included</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                type="number"
                formControlName="Number_Of_Lesson_Notes_Included"
                onKeyPress="if(this.value.length==10) return false;"
                (keypress)="preventEnteringString($event, 10)"
                class="form-control form-control-sm input-txt w-35"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height justify-content-start text-end flex-row-reverse">
              <div class="p-0">Number of Videos Included</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                type="number"
                formControlName="Number_Of_Videos_Included"
                onKeyPress="if(this.value.length==10) return false;"
                (keypress)="preventEnteringString($event, 10)"
                class="form-control form-control-sm input-txt w-35"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height justify-content-start text-end flex-row-reverse">
              <div class="p-0">Number of Flash Cards Included</div>
            </div>
            <div class="col-md-5 max-space-height">
              <input
                type="number"
                formControlName="Number_Of_Flashcards_Included"
                onKeyPress="if(this.value.length==10) return false;"
                (keypress)="preventEnteringString($event, 10)"
                class="form-control form-control-sm input-txt w-35"
              />
            </div>
          </div>
         <!-- IMAGE HERE Start -->
          <div class="row">
            <div class="col-md-6 px-md-0 d-flex max-space-height align-items-center flex-row-reverse">
              <div class="p-0 label-red">*</div>
              <div class="p-0">Course Plan Logo</div>
            </div>
            <div class="col-md-6 max-space-height">
              <div class="d-flex justify-content-start">
                <button
                  type="button"
                  (click)="uploadCourseImage.click()"
                  class="btn btn-sm bg-light border"
                  *ngIf="
                    addCoursePlanForm.value
                        .Course_Plan_Logo_Image_Deleted_Ind ==='Y' || !addCoursePlanForm.value
                        .Course_Plan_Logo_Image_File_Name_In_Server"
                >
                  Browse
                </button>

                <input
                  type="file"
                  hidden
                  #uploadCourseImage
                  accept=".jpg,.jpeg,.png"
                  (change)="imageHandle($event, 'file', 'previewFile')"
                />
                <img
                  class="image-object-fit"
                  [src]="

                    addCoursePlanForm.value
                        .Course_Plan_Logo_Image_Deleted_Ind ==='N'&&addCoursePlanForm.value
                        .Course_Plan_Logo_Image_File_Name_In_Server
                      ? (env.env === 'local' ? env.apiBaseUrl : '') +
                        addCoursePlanForm.value
                          .Course_Plan_Logo_Image_File_Location_Name +
                        '/' +
                        addCoursePlanForm.value
                          .Course_Plan_Logo_Image_File_Name_In_Server
                      : addCoursePlanForm.value.previewFile
                      ? addCoursePlanForm.value.previewFile
                      : '/assets/images/default_image.PNG'
                  "
                  alt=""
                  width="100"
                  height="100"
                />
                <div>
                  <i
                    class="fa fa-trash p-2 pointer-cursor delete-icon"
                    title="Delete Image"
                    style="top: 1.3em; position: relative; font-size: large"
                    (click)="deleteImage('Course_Plan_Logo_Image_Deleted_Ind')"
                    *ngIf="
                    addCoursePlanForm.value
                        .Course_Plan_Logo_Image_Deleted_Ind ==='N' &&
                      addCoursePlanForm.value
                        .Course_Plan_Icon_Image_File_Object_Id
                    "
                  ></i>
                  <i
                    class="fa fa-times p-2 pointer-cursor"
                    title="Discard Uploaded Image"
                    style="top: 1.2em; position: relative; font-size: x-large"
                    *ngIf="addCoursePlanForm.value.file"
                    (click)="clearUploadImage('file', 'previewFile')"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <!-- IMAGE END HERE -->
        </div>

        <div class="col-12  mt-2">
          <div class="row">
            <div class="col-md-2 d-flex mt-5 flex-row-reverse">
              <div class="p-0">Plan Caption</div>
            </div>
            <div class="col-md-9 max-space-height">
              <div class="d-flex justify-content-between">
                <div></div>
              <!-- <button
                type="button"
                [disabled]="!addCoursePlanForm.value.Course_Caption"
                class="btn btn-sm bg-light border mb-1"
                (click)="showPreviewPop()"
              >
                PREVIEW PLAN CAPTION
              </button> -->
              <div class="d-flex justify-content-end">
                <span>
                  <button
                    class="btn btn-sm bl-btn"
                  >
                    <span class="text-light">SAVE</span>
                  </button>
                </span>
                <span class="mx-2">
                  <button
                    type="button"
                    (click)="clear()"
                    class="btn btn-sm bg-light border"
                  >
                    CANCEL
                  </button>
                </span>
              </div>
            </div>
            <div class="d-flex flex-wrap justify-content-between mb-2">
  <div class="border p-2 rounded d-flex justify-content-between align-items-center mt-2 mb-2 w-100">

    <!-- Course description -->
    <div class="course-description" [innerHTML]="truncatedDescription"></div>

    <div class="d-flex gap-2">
      <!-- Edit button -->
      <button
        *ngIf="addCoursePlanForm.get('Course_Caption')?.value"
        type="button"
        class="btn btn-sm btn-light text-secondary d-flex align-items-center gap-1"
        (click)="openDescritionEditor()"
      >
        <i class="fa fa-pencil"></i> Edit
      </button>

      <!-- Preview button -->
      <button
        *ngIf="addCoursePlanForm.get('Course_Caption')?.value"
        type="button"
        class="btn btn-sm btn-light text-secondary d-flex align-items-center gap-1"
        (click)="previewTextDisplayFLag = true"
      >
        <i class="fa fa-eye"></i> Preview
      </button>

      <!-- Add button -->
      <button
        *ngIf="!addCoursePlanForm.get('Course_Caption')?.value"
        type="button"
        class="btn btn-sm btn-light text-secondary d-flex align-items-center gap-1"
        (click)="openDescritionEditor()"
      >
        <i class="fa fa-plus"></i> Add
      </button>
    </div>
  </div>
</div>
              <!-- <editor
                [init]="tinyConfig"
                formControlName="Course_Caption"
              ></editor> -->
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="">
            <div class="col-md-12 mt-2 d-flex justify-content-between align-items-center p-2 bg-light rounded">
              <h3 class="mb-0">Plan Features</h3>

              <div *ngIf="visibleCourseFeatures.length === 0"
                  class="d-flex align-items-center">
                <i class="fa fa-plus-circle plus-icon rounded-circle p-2 pointer-cursor"
                  title="Add Feature"
                  (click)="addCoursePlanFeature({}, true)"
                  style=" display: flex; align-items: center; justify-content: center;">
                </i>
              </div>
            </div>

            <div class="col-md-12 mb-5" *ngIf="visibleCourseFeatures.length > 0">
              <table style="width: 100%">
                <tr>
                  <th style="text-align: center;">Feature Name</th>
                  <th style="width: 95px; text-align: center;">New Feature</th>
                  <th style="width: 48px; text-align: center;">Value</th>
                  <th style="width: 150px; text-align: center;">Available Date</th>
                  <th style="width: 27%; text-align: center;">Description</th>
                  <th style="width: 117px; text-align: center;">Currency</th>
                  <th style="width: 105px; text-align: center;">Money Value</th>
                  <th style="text-align: center;">Tool Tip</th>
                  <th style="text-align: center;"></th>
                  <th style="text-align: center;"></th>
                  <th style="text-align: center;"></th>
                </tr>

                <ng-container formArrayName="coursePlanFeature">
                  <ng-container
                    *ngFor="
                      let courseFeature of coursePlanFeatures['controls'];
                      let i = index
                    "
                  >
                    <tr [formGroup]="courseFeature"
                    *ngIf="!courseFeature.get('delI')?.value"
                    >

                      <td>
                        <select
                          class="form-control form-control-sm inputfield-txt"
                          formControlName="featureName"
                          style="width: 100%;"
                          (change)="onFeatureChange(i)"
                          [ngClass]="{
                            'red-border-required': courseFeature?.get('featureName')?.touched && courseFeature?.get('featureName')?.invalid
                          }"
                        >
                          <option hidden></option>
                          <option
                            class="border-bottom"
                            *ngFor="let code of courseFeatureType"
                            [value]="code.Code"
                          >
                            {{ code.Description }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <select
                          class="form-control form-control-sm inputfield-txt"
                          formControlName="newR"
                          style="width: 100%;"
                          [ngClass]="{
                            'red-border-required': courseFeature.get('newR')?.touched && courseFeature.get('newR')?.invalid
                          }"
                        >
                          <option hidden></option>
                          <option
                            class="border-bottom"
                            *ngFor="let code of optionDesc"
                            [value]="code.Code"
                          >
                            {{ code.Description }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <select
                          class="form-control form-control-sm inputfield-txt"
                          formControlName="value"
                          style="width: 100%;"
                          [ngClass]="{
                            'red-border-required': courseFeature.get('value')?.touched && courseFeature.get('value')?.invalid
                          }"
                        >
                          <option hidden></option>
                          <option
                            class="border-bottom"
                            *ngFor="
                              let code of (
                                (addCoursePlanForm?.value?.coursePlanFeature || [])[i] || {}
                              )?.featureName == 'MockExams' ||
                              (
                                (addCoursePlanForm?.value?.coursePlanFeature || [])[i] || {}
                              )?.featureName === 'PracticeExams'
                                ? counter
                                : option
                            "
                            [value]="code"
                          >
                            {{ code }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <input
                          formControlName="availableDate"
                          type="date"
                          [attr.min]="today"
                          class="form-control form-control-sm input-txt"
                          style="width: 100%;"
                          [ngClass]="{
                            'red-border-required': courseFeature.get('availableDate')?.touched && courseFeature.get('availableDate')?.invalid
                          }"
                        />
                      </td>
                      <td>
                        <input
                          formControlName="description"
                          type="text"
                          class="form-control form-control-sm input-txt"
                          style="width: 100%;"
                          [ngClass]="{
                            'red-border-required': courseFeature.get('description')?.touched && courseFeature.get('description')?.invalid
                          }"
                        />
                      </td>
                      <td>
                        <select
                          class="form-control form-control-sm inputfield-txt"
                          formControlName="currency"
                          style="width: 100%;"
                          [ngClass]="{
                            'red-border-required': courseFeature.get('currency')?.touched && courseFeature.get('currency')?.invalid
                          }"
                        >
                          <option hidden></option>
                          <option
                            class="border-bottom"
                            *ngFor="let code of currency"
                            [value]="code.Code"
                          >
                            {{ code.Description }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <input
                          formControlName="moneyValue"
                          type="text"
                          (keyup)="preventEnteringDecimalString($event, 10)"
                          class="form-control form-control-sm input-txt text-end"
                          style="width: 100%;"
                          [ngClass]="{
                            'red-border-required': courseFeature.get('moneyValue')?.touched && courseFeature.get('moneyValue')?.invalid
                          }"
                        />
                      </td>
                      <td>
                        <input
                          formControlName="toolTip"
                          type="text"
                          class="form-control form-control-sm input-txt"
                          style="width: 100%;"
                          [ngClass]="{
                            'red-border-required': courseFeature.get('toolTip')?.touched && courseFeature.get('toolTip')?.invalid
                          }"
                        />
                      </td>
                      <td></td>
                      <td>
                        <i
                        *ngIf="i !==0"
                          class="fa fa-trash pointer-cursor delete-icon"
                          (click)="removeCoursePlan(i)"
                        ></i>
                      </td>
                      <td>
                        <ng-container
                          *ngIf="isLastVisibleFeature(i) && !courseFeature.get('delI')?.value"
                        >
                          <i
                            class="fa fa-plus pointer-cursor"
                            (click)="addCoursePlanFeature({}, true)"
                          ></i>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </table>

            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>

<section>
  <app-preview-text
    [previewDialogDisplayFlag]="previewTextDisplayFLag"
    [previewText]="addCoursePlanForm.value.Course_Caption"
    (displayOff)="displayDialogOff()"
  ></app-preview-text>
</section>
